import { OrderDoc, OrderProduct, ProductStateCode } from '@gooduncles/gu-app-schema';
import { Button } from 'antd';
import { FC } from 'react';
import { settlementDayTable } from 'src/constants';

import { IssueModalSource, useOrderProductIssueModal } from 'src/stores/useOrderProductIssueModal';

type ProductWithOrder = OrderProduct & {
  order: OrderDoc & { store?: { storeName?: string; storeNickname?: string } };
};

/**
 * 품절 버튼
 * 정산일이 지나지 않았고, 정산이 완료되지 않은 주문의 상품에만 노출된다.
 * 클릭 시 OrderProductIssueModal을 열어 품절 처리를 진행한다.
 */
const SoldOutCellRenderer: FC = (params: any) => {
  const data: ProductWithOrder = params.data;
  if (!data) {
    return null;
  }

  const orderDay = new Date(data.order.orderDate).getDay();
  const today = new Date().getDay();
  const unsettled = settlementDayTable[today].some((settlementDay) => settlementDay === orderDay);

  // 정산일이 지나거나, 정산이 완료된 주문의 항목을 품절 처리할 수 없다.
  if (!unsettled || data.order.settledAt) {
    return null;
  }

  if (data.state === ProductStateCode.OUTOFSTOCK) {
    return <span>품절 처리됨</span>;
  }

  const handleClick = () => {
    // AG-Grid context에서 source 가져오기
    const source = params.context?.issueModalSource as IssueModalSource | undefined;
    useOrderProductIssueModal.getState().open({
      order: data.order,
      store: {
        storeId: data.order.storeId,
        storeName: data.order.store?.storeNickname ?? data.order.store?.storeName ?? '',
      },
      product: data,
      changeType: 'sold_out',
      source: source ?? null,
    });
  };

  return (
    <Button danger onClick={handleClick}>
      품절
    </Button>
  );
};

export default SoldOutCellRenderer;
